import VoucherSearchInput from 'domains/voucher/molecules/voucher-search-input'
import VoucherDetailView from 'domains/voucher/organisms/detail-view'
import withLoader from 'hocs/with-loader'
import CardLoarder from 'components/organisms/card-loader'
import { useEffect, useState } from 'react'
import { Button, Modal, ModalBody } from 'reactstrap'
import CustomerOrdersApiV2 from 'api/v2/admins/customer-orders-api-v2'
import PropTypes from 'prop-types'
import VoucherList from 'domains/voucher/organisms/voucher-modal/voucher-list'

const propTypes = {
  isOpen                  : PropTypes.bool,
  toggle                  : PropTypes.func,
  handleClickVoucherApply : PropTypes.func,
  handleClickApply        : PropTypes.func
}

const VoucherModal = ({ isOpen, toggle, handleClickVoucherApply }) => {

  const [ isLoading,  setIsLoading ]            = useState(false)
  const [ vouchers,   setVouchers ]             = useState([])
  const [ search,     setSearch ]               = useState('')
  const [ selectedVoucher, setSelectedVoucher ] = useState(undefined)

  /**
   * Fetch available vouchers for customer
   */
  useEffect(() => {
    if (search !== '') getVouchers({ show_on_checkout: '' })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getVouchers = async ({ code, show_on_checkout }) => {
    setIsLoading(true)
    const queryParams = { code, show_on_checkout }
    CustomerOrdersApiV2.getVoucher(queryParams)
      .then((response) => {
        const vouchers = response.data.vouchers
        setVouchers(vouchers)
        setIsLoading(false)
      })
      .catch(() => {
        alert('Unable to fetch your vouchers. Please contact Customer Service')
      })

  }

  /**
   * Update state when user types into input
   *
   * @param {event} event - onChange event from input
   */
  const handleChangeSearchInput = (event) => {
    const search = event.target.value
    // remove empty character
    setSearch(search.replace(/\s/g, ''))
  }

  /**
   * Calls endpoint when user clicks "Search" button
   */
  const handleClickSearch = () => {
    if (!search) return
    setIsLoading(true)
    getVouchers({
      code: search
    })
  }

  /**
   * Click on a VoucherCard to show details of the voucher
   * Updates `selectedVoucher`
   */
  const handleClickVoucher = (voucher) => {
    setSelectedVoucher(voucher)
  }

  const VoucherListWithLoader = withLoader(VoucherList, CardLoarder)

  /**
   * Goes back to displaying the <VoucherList>
   * - reset `selectedVoucher` state
   */
  const handleClickBack = () => {
    setSelectedVoucher(undefined)
  }

  /**
   * Wrapper around `handleClickApplyVoucher` prop
   * - reset `selectedVoucher` state
   * - call prop `handleClickVoucherApply` in `/checkout` page
   * @param {voucher} voucher - to apply
   */
  const handleClickApply = (voucher) => {
    setSelectedVoucher(undefined)
    handleClickVoucherApply(voucher)
  }

  return (
    <Modal
      isOpen={ isOpen }
      toggle={ toggle }
    >
      <ModalBody>

        {
          selectedVoucher && (
            <>
              <Button color='default' onClick={ handleClickBack }>{ '< Back' }</Button>
              <VoucherDetailView
                voucher={ selectedVoucher }
                handleClickApply={ handleClickApply }
              />
            </>
          )
        }
        {
          !selectedVoucher && (
            <>
              <div className='mb-3 px-md-5'>
                <VoucherSearchInput
                  onChange={ handleChangeSearchInput }
                  onClickSearch={ handleClickSearch }
                />
              </div>
              <VoucherListWithLoader
                vouchers={ vouchers }
                onClickItem={ handleClickVoucher }
                isLoading={ isLoading }
              />
            </>
          )
        }

      </ModalBody>
    </Modal>
  )
}

VoucherModal.propTypes = propTypes

export default VoucherModal